import { Injectable, computed, signal } from '@angular/core';

/**
 * Estado global de carga. Cuenta las peticiones HTTP en curso (lo alimenta el
 * loadingInterceptor) para mostrar una barra de progreso superior.
 * También puede usarse manualmente con begin()/end() para procesos no-HTTP.
 */
@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly pending = signal(0);
  readonly isLoading = computed(() => this.pending() > 0);

  begin(): void {
    this.pending.update(n => n + 1);
  }

  end(): void {
    this.pending.update(n => Math.max(0, n - 1));
  }
}
